import { useRef, type ReactNode, type RefObject } from 'react'
import { Upload } from 'lucide-react'
import { Modal } from './ui'
import { siteText } from '../siteText'
import '../views/SourcesView.css'

export function UploadComposerModal({ title, header, onClose, children, className = '' }: { className?: string; title: string; header?: ReactNode; onClose: () => void; children: ReactNode }) {
  return <Modal className={`sources-composer-modal ${className}`} width="520px" title={title} hideTitle headerContent={header ?? <span className="upload-composer-heading">{title}</span>} onClose={onClose}>{children}</Modal>
}

export function UploadFileChoice({ file, onChoose, accept, label, inputLabel, disabled = false, inputRef }: {
  file: File | null; onChoose: (file: File | undefined) => void; accept: string; label: string; inputLabel: string; disabled?: boolean; inputRef?: RefObject<HTMLInputElement>
}) {
  const localInput = useRef<HTMLInputElement>(null)
  const input = inputRef ?? localInput
  return <>
    <input ref={input} hidden type="file" accept={accept} aria-label={inputLabel} disabled={disabled} onChange={event => onChoose(event.target.files?.[0])} />
    <button type="button" className="sources-file-choice sources-upload-choice" disabled={disabled} onClick={() => input.current?.click()} onDragOver={event => event.preventDefault()} onDrop={event => { event.preventDefault(); if (!disabled) onChoose(event.dataTransfer.files[0]) }}>
      <Upload size={22} aria-hidden="true" /><span>{siteText(file ? file.name : label)}</span>
    </button>
  </>
}
